import { render } from "./Instruments.vue?vue&type=template&id=21165c18"
import script from "./Instruments.vue?vue&type=script&lang=js"
export * from "./Instruments.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__